// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_29y5Tnnl","section":"hJNjapnx","content":"_3BdRg355","details-container":"wz2S66YK","contactDiv":"_1zzmCHic","firstCol":"iVpz0-ze","secondCol":"_3CwxASNh","mediaUl":"_3cmq5pW5","social_icon":"_1x0dLzV8","contact-row":"_2Y23mNwX","text-col":"Ot4T1osP","contact-col":"_17Ow7fFb","social-col":"_2SkKMtM-"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/components/End/End.styl
// module id = 217
// module chunks = 0